var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlphanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#808284;stroke-width:1.0405;stroke-miterlimit:10;}\n\t.st1{fill:none;}\n\t.st2{fill:url(#XMLID_2_);}\n\t.st3{fill:url(#XMLID_3_);}\n\t.st4{fill:url(#XMLID_4_);}\n\t.st5{fill:#177DC1;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1320_",
    className: "st0",
    d: "M98,49.2L49.8,1h0L2,49.4v0l29.7,30c0,0,0,0,0,0h-24c-1,0-1.8,0.8-1.8,1.8v15.1 c0,1.1,0.9,2,2,2h84c1,0,1.7-0.8,1.7-1.7V81.1c0-0.9-0.7-1.6-1.6-1.6H68.1c0,0,0,0,0,0L98,49.2C98,49.2,98,49.2,98,49.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1306_"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1319_",
    className: "st1",
    points: "51.7,75.5 49,78.6 51.4,78.6 54.2,75.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1318_",
    className: "st1",
    points: "57.4,75.5 54.7,78.6 57.1,78.6 59.9,75.5  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1317_",
    className: "st1",
    points: "46,75.5 43.3,78.6 45.7,78.6 48.5,75.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1316_",
    className: "st1",
    points: "40.3,75.5 37.5,78.6 40,78.6 42.8,75.5  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1313_",
    className: "st1",
    d: "M76.4,60.8c2.1,0,3.5-0.4,4.3-0.8l-0.4-1.7c-0.9,0.4-1.9,0.7-3.6,0.7 c-2.4,0-4.4-1.3-4.5-4.6h9.2c0-0.2,0.1-0.6,0.1-1.1c0-2.4-1.1-6.3-5.4-6.3c-3.8,0-6.1,3.1-6.1,7.2C70,58.1,72.3,60.8,76.4,60.8z  M75.9,48.7c2.7,0,3.3,2.4,3.3,3.9h-6.9C72.5,50.9,73.5,48.7,75.9,48.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -357.1107,
    y1: 337.1223,
    x2: -357.1107,
    y2: 304.7774,
    gradientTransform: "matrix(2.6667 0 0 -2.6667 1012.6047 904.7312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2CABE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4095,
    style: {
      stopColor: "#1483C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8157,
    style: {
      stopColor: "#0C5FAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#09509E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1310_",
    className: "st2",
    d: "M40.3,75.5h2.5l-2.8,3h3.3l2.7-3h2.5l-2.8,3h3.3l2.7-3h2.5l-2.8,3h3.3l2.7-3h2.5l-2.8,3 h8.1l20-20c-0.2-0.6-0.2-1.4-0.2-2.2v-7.2h-2v-1.8h2V44l2.3-0.6v3.8h3.4v1.8h-3.4v7.2c0,0.1,0,0.2,0,0.2l7.1-7.1L50,5.1 L34.7,20.4c7.4-0.3,13.6,5.3,13.4,16.2l6.7-14.5h8.6L48,53.1c-0.6,1.7-0.7,14.8,7.9,7.6c0,0,0-0.1,0.1-0.1v-9.7 c0-1.4,0-2.5-0.1-3.6h2.1l0.1,2.2h0.1c0.6-1.3,2.2-2.5,4.3-2.5c1.8,0,4.6,1.1,4.6,5.6v7.9h-2.4v-7.7c0-2.2-0.8-3.9-3-3.9 c-1.6,0-2.8,1.1-3.2,2.5c-0.1,0.3-0.2,0.7-0.2,1.1v7.7c0,0,0,0.1,0,0.1v0.2l0,0c-2,5.4-16.1,18-14.6-2.5 c-3.3,5.8-10.6,10.8-17.4,12l7,7l1.3-1.5h2.5l-2.6,2.7l0.3,0.3h2.7L40.3,75.5z M76.1,46.9c4.2,0,5.4,3.8,5.4,6.3 c0,0.5-0.1,0.9-0.1,1.1h-9.2c0.1,3.2,2.1,4.6,4.5,4.6c1.7,0,2.7-0.3,3.6-0.7l0.4,1.7c-0.8,0.4-2.3,0.8-4.3,0.8 c-4,0-6.4-2.7-6.4-6.7C70,50.1,72.3,46.9,76.1,46.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -375.9507,
    y1: 337.1223,
    x2: -375.9507,
    y2: 304.777,
    gradientTransform: "matrix(2.6667 0 0 -2.6667 1012.6047 904.7312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2CABE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4095,
    style: {
      stopColor: "#1483C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8157,
    style: {
      stopColor: "#0C5FAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#09509E"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1309_",
    className: "st3",
    d: "M14.4,40.7l-8.8,8.8l6.3,6.3C12,51.7,12.7,46.7,14.4,40.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -367.4501,
    y1: 337.1222,
    x2: -367.4501,
    y2: 304.7774,
    gradientTransform: "matrix(2.6667 0 0 -2.6667 1012.6047 904.7312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2CABE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4095,
    style: {
      stopColor: "#1483C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8157,
    style: {
      stopColor: "#0C5FAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#09509E"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1308_",
    className: "st4",
    d: "M33.2,62.5C43.8,53.9,43.8,45,45.2,41.8c1.3-17.2-12-28.1-21.7-1.1 C13.4,73,29.4,65.9,33.2,62.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1307_",
    className: "st5",
    d: "M75.9,48.7c-2.4,0-3.5,2.3-3.6,3.9h6.9C79.2,51.1,78.5,48.7,75.9,48.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1303_",
    d: "M13.4,87h1.4v6.7h-1.4v-1.3c-0.7,1-1.5,1.5-2.6,1.5c-0.9,0-1.6-0.3-2.3-1c-0.6-0.7-0.9-1.5-0.9-2.5 c0-0.9,0.3-1.7,1-2.5c0.6-0.7,1.4-1.1,2.2-1.1c0.5,0,1,0.1,1.5,0.4c0.5,0.3,0.8,0.6,1.1,1.1L13.4,87L13.4,87z M13.6,90.3 c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.4-1-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.5c0,0.6,0.2,1.2,0.6,1.6 c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.6-0.6C13.4,91.5,13.6,91,13.6,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1302_",
    d: "M17.1,83.2h1.4v10.5h-1.4V83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1299_",
    d: "M22.2,87v1.3c0.7-1,1.5-1.5,2.6-1.5c0.9,0,1.6,0.3,2.2,1c0.6,0.7,0.9,1.5,0.9,2.5c0,1-0.3,1.8-1,2.5 c-0.6,0.7-1.4,1.1-2.2,1.1c-0.5,0-1-0.1-1.4-0.4c-0.4-0.3-0.8-0.6-1.1-1.1v4.5h-1.4V87H22.2z M26.4,90.3c0-0.6-0.2-1.1-0.6-1.5 c-0.4-0.4-1-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.6,0.6c-0.4,0.4-0.7,1-0.7,1.5c0,0.6,0.2,1.1,0.6,1.6c0.4,0.4,1,0.7,1.6,0.7 c0.6,0,1.2-0.2,1.6-0.6C26.2,91.5,26.4,90.9,26.4,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1298_",
    d: "M29.4,83.2h1.4v4.9c0.4-0.4,0.8-0.8,1.1-1c0.3-0.2,0.8-0.3,1.2-0.3c0.6,0,1.1,0.2,1.5,0.6 c0.4,0.4,0.6,1,0.6,1.6v4.6h-1.4v-4.2c0-0.4-0.1-0.8-0.3-1C33.3,88.1,33,88,32.7,88c-0.5,0-1,0.2-1.3,0.6 C31,89,30.8,89.4,30.8,90v3.7h-1.4V83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1295_",
    d: "M42.6,87H44v6.7h-1.4v-1.3c-0.7,1-1.5,1.5-2.6,1.5c-0.9,0-1.6-0.3-2.3-1c-0.6-0.7-0.9-1.5-0.9-2.5 c0-0.9,0.3-1.7,1-2.5c0.6-0.7,1.4-1.1,2.2-1.1c0.5,0,1,0.1,1.5,0.4c0.5,0.3,0.8,0.6,1.1,1.1L42.6,87L42.6,87z M42.8,90.3 c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.4-1-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.5c0,0.6,0.2,1.2,0.6,1.6 c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.6-0.6C42.6,91.5,42.8,91,42.8,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1294_",
    d: "M45.9,92.7c0-0.3,0.1-0.5,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.5,0.1,0.8,0.3 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.5-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.5-0.1-0.8-0.3C46,93.3,45.9,93,45.9,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1293_",
    d: "M49.5,93.7V87h1.4V88c0.4-0.4,0.8-0.8,1.1-1c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.1,0.2,1.5,0.6 c0.4,0.4,0.6,0.9,0.6,1.4v4.8h-1.4v-4.4c0-0.4-0.1-0.6-0.3-0.9C53.3,88.1,53,88,52.7,88c-0.5,0-0.9,0.2-1.2,0.6 c-0.3,0.4-0.5,0.9-0.5,1.4v3.6L49.5,93.7L49.5,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    d: "M63.7,90.6H58c0.1,0.7,0.4,1.2,0.9,1.5c0.4,0.3,0.9,0.5,1.4,0.5c0.8,0,1.5-0.3,2-1l1,0.8 c-0.8,1-1.8,1.5-3.1,1.5c-1,0-1.8-0.3-2.5-1c-0.7-0.7-1-1.5-1-2.5c0-1,0.3-1.8,1-2.5c0.7-0.7,1.5-1,2.5-1c1,0,1.8,0.3,2.5,1.1 C63.4,88.6,63.7,89.5,63.7,90.6z M58.2,89.5h4.1c-0.4-0.9-1.1-1.4-2-1.4C59.3,88.1,58.6,88.6,58.2,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    d: "M65.8,85h1.4V87h1.4v1.3h-1.4v5.4h-1.4v-5.4h-1.1V87h1.1V85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    d: "M69.6,92.7c0-0.3,0.1-0.5,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.5,0.1,0.8,0.3 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.5-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.5-0.1-0.8-0.3C69.7,93.3,69.6,93,69.6,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    d: "M73.7,83.2h1.4v5.2c0.6-1,1.5-1.5,2.6-1.5c0.9,0,1.6,0.3,2.3,1c0.6,0.7,1,1.5,1,2.5c0,1-0.3,1.8-0.9,2.5 c-0.6,0.7-1.4,1.1-2.2,1.1c-0.5,0-1-0.1-1.5-0.4c-0.5-0.3-0.9-0.7-1.1-1.2v1.4h-1.4V83.2z M79.4,90.3c0-0.6-0.2-1.1-0.6-1.6 c-0.4-0.4-1-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.6c0,0.6,0.2,1.2,0.6,1.6c0.4,0.4,1,0.6,1.6,0.6 c0.6,0,1.1-0.2,1.5-0.6C79.2,91.4,79.4,90.9,79.4,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    d: "M88.3,83.2h1.4v10.5h-1.4v-1.4c-0.6,1.1-1.5,1.6-2.6,1.6c-0.9,0-1.6-0.3-2.3-1.1 c-0.6-0.7-0.9-1.5-0.9-2.5c0-1,0.3-1.8,1-2.5c0.6-0.7,1.4-1,2.3-1c0.5,0,1,0.1,1.5,0.4c0.4,0.3,0.8,0.7,1.1,1.1L88.3,83.2 L88.3,83.2z M88.4,90.3c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.4-1-0.6-1.6-0.6c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.4-0.6,1-0.6,1.6 c0,0.6,0.2,1.1,0.6,1.6c0.4,0.4,1,0.7,1.5,0.7c0.6,0,1.2-0.2,1.6-0.6C88.2,91.5,88.4,90.9,88.4,90.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphanet);
export default __webpack_public_path__ + "static/media/alphanet.2c3194937fefb09d8bc754a9ac0d3a20.svg";
export { ForwardRef as ReactComponent };